import "@Styles/Main.less"

import DataWebPage from "@Scripts/Pages/DataWebPage";
import BasePage from "@Scripts/Pages/BasePage";
import HomePage from "@Scripts/Pages/HomePage";
import ProductDetailPage from "@Scripts/Pages/ProductDetailPage";
import CheckoutConfirmPage from "@Scripts/Pages/CheckoutConfirmPage";
import CookieTermsPage from "@Scripts/Pages/CookieTermsPage";

let App: any = {
    instances: {},
    pages: {},
    routes: {}
};

App.pages.DataWebPage = DataWebPage;
App.pages.BasePage = BasePage;
App.pages.HomePage = HomePage;
App.pages.ProductDetailPage = ProductDetailPage;
App.pages.CheckoutConfirmPage = CheckoutConfirmPage;
App.pages.CookieTermsPage= CookieTermsPage;

(<any>window).App = App;